import allImgPaths from 'assets/images'
import { InputTextField } from 'components/InputField'
import Otp from 'components/Otp'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import objectiveIcon from "./../../assets/images/objective-icon.svg";
import CustomSelect from 'components/common/CustomSelect'
import RfpSocialLinks from 'components/rfp/rfpInnerBox/RfpSocialLinks'
import CustomCheckBox from 'components/CustomCheckBox'

const Onboarding7 = () => {

    const handleButtonClick = (event: any) => {
        event?.preventDefault()
        document.getElementById('file-input')?.click();
    }

    const [formData, setFormData] = useState<any>('');

    const handleObjectiveChange = (event: any) => {
        setFormData({
            [event.target.name]: event.target.value,
        });
        if (event.target.name === "objective") {
            let getTextArea = document.getElementById("textAreaRef");
            if (getTextArea) {
                if (event.target.value.length === 0) {
                    event.target.style.height = "24px";
                } else {
                    event.target.style.height = "auto";
                    event.target.style.height = event.target.scrollHeight + "px";
                }
            }
        }
    };

    const facilityCategory = [
        { catName: 'Accommodation', imgUrl: allImgPaths.vendorAccomodationIcon },
        { catName: 'Food & Beverage', imgUrl: allImgPaths.vendorAccomodationIcon },
        { catName: 'Activities & Experiences', imgUrl: allImgPaths.vendorAccomodationIcon },
        { catName: 'Transportation', imgUrl: allImgPaths.vendorAccomodationIcon },
        { catName: 'Gifting', imgUrl: allImgPaths.vendorAccomodationIcon },
        { catName: 'Entertainment', imgUrl: allImgPaths.vendorAccomodationIcon },
        { catName: 'Decor & Rental', imgUrl: allImgPaths.vendorAccomodationIcon },
        { catName: 'Technology Partner', imgUrl: allImgPaths.vendorAccomodationIcon },
        { catName: 'Security & Stafffing', imgUrl: allImgPaths.vendorAccomodationIcon },
        { catName: 'Marketing & Promotion', imgUrl: allImgPaths.vendorAccomodationIcon },
        { catName: 'Others', imgUrl: allImgPaths.vendorAccomodationIcon }
    ]

    const facilityAdditionalFeature = [
        { catName: 'Parking' },
        { catName: 'Valet Parking' },
        { catName: 'Wheelchair accessibilty' },
        { catName: 'Public Transportation' },
        { catName: 'AV capabilites' },
        { catName: 'Business center, Fax, Printing' },
        { catName: 'Free Wi-Fi' },
        { catName: 'Onsite security' },
        { catName: 'Basic shopping' },
        { catName: 'ATMs' },
        { catName: 'Laundry Service' }
    ]

    return (
        <div className="flex">
            {/* Left banner */}
            <div className="w-2/6">
                <div className="bg-[#1E0AF5] flex flex-col justify-start items-center h-screen">
                    <div className="pt-[77px]">
                        <img className='pb-52 -ml-8' src={allImgPaths.vendorWhiteIcon} alt="" />

                        <div className="pb-10 last:pb-0 relative line-shape done">
                            <h3 className='text-sm font-interSemiBold text-white pb-1 circle-shape'>Basic Details</h3>
                            <ul>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>General Information</li>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>Contact Info</li>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>Social Media Presence</li>
                            </ul>
                        </div>

                        <div className="pb-10 last:pb-0 relative line-shape active">
                            <h3 className='text-sm font-interSemiBold text-white pb-1 circle-shape'>Facility Details</h3>
                            <ul>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>Count & capacity</li>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>Secondary services & features</li>
                            </ul>
                        </div>

                        <div className="pb-10 last:pb-0 relative line-shape">
                            <h3 className='text-sm font-interSemiBold text-white pb-1 circle-shape'>Legal & Compliances</h3>
                            <ul>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>Upload licenses, certification & Insurance</li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>

            {/* Right banner */}
            <div className="w-4/6 flex flex-col">
                <div className="w-full h-screen flex items-center overflow-y-auto">
                    <div className="w-full max-w-[720px] mx-auto">

                        {/* Heading */}
                        <h2 className="font-interSemiBold text-[30px] text-[#101828] pb-3">Legal & Compliances</h2>
                        <p className='text-[#475467] text-base mb-8'>Upload all the relevant documents you possess</p>

                        {/* Chips */}
                        <div className="mb-11">
                            <p className='px-4 py-4 border border-[#E4E7EC] rounded bg-[#F9FAFB]'><span className='text-sm text-[#344054] font-interSemiBold'>Get Verified Today!</span> Simply upload your compliance documents and permits to become a verified vendor on our platform and expand your reach to event organizers.</p>
                        </div>

                        <span className='text-sm text-[#667085] inline-block pb-2'>Licenses, Certifications and Insurance</span>

                        <div className="overflow-y-auto max-h-[calc(100vh_-_580px)] pt-4">
                            <div className="border border-[#EAECF0] bg-[#F9FAFB] rounded-lg px-4 py-4 relative w-[97%] mb-6 last:mb-0">

                                <span className="absolute -top-4 -right-4 border border-[#F2F4F7] rounded-full p-1 cursor-pointer bg-white hover:bg-[#f2f4f7]">
                                    <img className="" src={allImgPaths.crossIcon} alt="" />
                                </span>

                                <div className="flex gap-x-4 mb-4">
                                    <div className="w-full">
                                        <p className="text-[15px] text-[#344054] font-interMedium pb-2.5">Type</p>
                                        <div className="modal-select-box fete-settings-modals bg-white">
                                            <CustomSelect
                                                options={
                                                    [
                                                        { label: "value 1", value: "value 1" },
                                                        { label: "value 2", value: "value 2" }
                                                    ]
                                                }
                                                onChange={() => { }}
                                                extendedOption={false}
                                            />
                                            {/* <p className='text-[#D92D20] text-sm pt-0.5'>error</p> */}
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <p className="text-[#344054] text-sm font-interMedium pb-1.5">
                                        Description <span className='text-sm text-[#667085]'>(Optional)</span>
                                    </p>
                                    <div className="relative">
                                        <div className="border border-[#D0D5DD] hover:border-[#1E0AF5] focus-within:border-[#1E0AF5] rounded-lg flex items-start gap-x-2 py-2 px-3 bg-white">
                                            <img
                                                className="w-[22px] h-[22px] flex-shrink-0 mt-0.5"
                                                src={objectiveIcon}
                                                alt="star icon"
                                            />
                                            <textarea
                                                id="textAreaRef"
                                                name="objective"
                                                maxLength={200}
                                                value={formData.objective}
                                                onChange={handleObjectiveChange}
                                                className="placeholder:text-[#344054] placeholder:text-base text-base text-[#344054] w-full h-[24px]"
                                                placeholder="Enter goal of the fete"
                                                style={{
                                                    width: "100%",
                                                    boxSizing: "border-box",
                                                    overflow: "hidden",
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <div className="">
                                        <span className='text-[#344054] text-sm font-interMedium pb-2 block'>Upload releveant documentation</span>
                                        <input
                                            className="flex items-center gap-x-1.5 border border-[#D0D5DD] hover:border-[#1e0af5] rounded-lg py-2.5 px-3.5"
                                            type="file"
                                            id="file-input"
                                            accept=".jpg,.jpeg,.png"
                                            style={{ display: 'none' }}
                                            onChange={() => { }}
                                        />
                                        <button className="flex items-center gap-x-1.5 border border-[#D0D5DD] hover:border-[#1e0af5] rounded-lg py-2.5 px-3.5 w-full bg-white" onClick={handleButtonClick}>
                                            <img src={allImgPaths.vendorFileAttachmentIcon} alt="upload Iocn" />
                                            <span className="text-[#667085]">Click to Browse...</span>
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>


                        <div className='flex justify-center mt-4'>
                            <button onClick={() => { }} className="border border-[#1E0AF5] hover:bg-[#E8E6FE] rounded-lg flex items-center gap-x-2 py-2.5 px-3.5 mb-6 mt-1.5" type="button">
                                <img src={allImgPaths.plusCircleBlueIcon} alt='' />
                                <span className='text-[#1E0AF5] text-sm font-interSemiBold'>
                                    Add More
                                </span>
                            </button>
                        </div>

                        <div className="flex items-center justify-between mt-10">
                            <Link className='text-[#4B3BF7] cursor-pointer font-interSemiBold text-sm hover:text-[#0C0462]' to={'/'}>
                                Skip this step
                            </Link>

                            <div className="flex gap-x-3 justify-end">
                                <button className="rounded-md border border-[#1E0AF5] text-[#1E0AF5] hover:bg-[#E8E6FE] flex gap-x-1.5 items-center !pl-2 !pr-4 font-interSemiBold" type="submit">
                                    <img className='w-[22px] h-[22px]' src={allImgPaths.vendorLeftArrowBlueIcon} alt="" />
                                    Prev
                                </button>
                                <button className="submit-btn-blue blue-btn-hover flex gap-x-1.5 items-center !pl-4 !pr-2" type="submit">
                                    Next
                                    <img className='w-[22px] h-[22px]' src={allImgPaths.vendorLeftArrowIcon} alt="" />
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Onboarding7